import { render, staticRenderFns } from "./send-message.vue?vue&type=template&id=7fd98c71&scoped=true&"
import script from "./send-message.vue?vue&type=script&lang=js&"
export * from "./send-message.vue?vue&type=script&lang=js&"
import style0 from "./send-message.vue?vue&type=style&index=0&id=7fd98c71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd98c71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDivider,VForm,VHover,VIcon,VSpacer,VTextField})
